import { API_USER_URL } from "@/env";
import { CommissionListAPI } from "./type";
import { message } from "antd";

const API_USE = API_USER_URL || '';

async function getCommissionsList(
    start_date?: string,
    end_date?: string,
    month?: string,
    year?: string,
    status?: 'pending' | 'approved' | 'paid' | 'rejected' | 'waiting_tax_check',
    page?: number,
    limit?: number
): Promise<CommissionListAPI> {
    const token = localStorage.getItem('token') || '';
    if (!token) {
        throw new Error('No authentication token found');
    }

    const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user') || '{}') : null;
    if (!user) {
        throw new Error('No user information found');
    }
    try {
        const queryParams = new URLSearchParams();
        if (start_date) queryParams.append('started_date', start_date);
        if (end_date) queryParams.append('end_date', end_date);
        if (month) queryParams.append('month', month);
        if (year) queryParams.append('year', year);
        if (status) queryParams.append('status', status);
        if (page) queryParams.append('page', page.toString());
        if (limit) queryParams.append('limit', limit.toString());
        const response = await fetch(`${API_USE}/api/v1/be/commissions?${queryParams.toString()}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
        });
        if (!response.ok) {
            message.error('Error fetching commissions list');
        }
        const data = await response.json();
        return data as CommissionListAPI;
    } catch (error) {
        console.error('Failed to fetch commissions list:', error);
        throw error;
    }
}

async function getCommissionsStats(): Promise<
    {
        status: boolean,
        message: string,
        data?: {
            total_recorded: number,
            total_pending: number,
            total_earned: number,
            total_tax_fee: number
        }
    }> {
    const token = localStorage.getItem('token') || '';
    if (!token) {
        throw new Error('No authentication token found');
    }

    try {
        const response = await fetch(`${API_USE}/api/v1/be/commissions/stats`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
        });
        if (!response.ok) {
            message.error('Error fetching commissions stats');
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Failed to fetch commissions stats:', error);
        throw error;
    }
}

export {
    getCommissionsList,
    getCommissionsStats
};